import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.LegalStructureEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    legalStructureEnumList: { items: data, total },
  } = await sdk.getListLegalStructureEnum(filterSortPage({ sort, pagination }));

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { legalStructureEnum: data } = await sdk.getOneLegalStructureEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { legalStructureEnumMany: data } = await sdk.getManyLegalStructureEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const legalStructureEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
